module.exports = __webpack_public_path__ + "static/media/mgm_altHero.cde62045.jpg";